import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFile, faFileAudio, faFileImage, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { buildMediaUrl } from "../Tickets/ticketUtils";

const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const isAudioFile = (file) => /^audio\//i.test(file.contentType || "") ||
  /\.(mp3|wav|m4a|aac|ogg|webm|weba)$/i.test(file.fileName || "");

const fileIconFor = (name = "") => {
  if (/\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(name)) return faFileImage;
  if (/\.pdf$/i.test(name)) return faFilePdf;
  return faFile;
};

export default function TaskFileAttachment({ file }) {
  const isAudio = isAudioFile(file);
  const url = buildMediaUrl(file.fileUrl);
  const download = (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      download={file.fileName}
      className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs transition hover:border-orange-300 dark:border-gray-700 dark:bg-gray-800"
    >
      <FontAwesomeIcon icon={isAudio ? faFileAudio : fileIconFor(file.fileName)} className="text-slate-400" />
      <span className="min-w-0 flex-1 truncate text-slate-700 dark:text-gray-200">{file.fileName}</span>
      <span className="shrink-0 text-slate-400">{formatFileSize(file.fileSize)}</span>
      <FontAwesomeIcon icon={faDownload} className="shrink-0 text-slate-400" />
    </a>
  );

  if (!isAudio) return download;

  return (
    <div className="w-full max-w-sm space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-2 dark:border-gray-700 dark:bg-gray-900">
      {download}
      <audio controls preload="none" src={url} aria-label={`Play ${file.fileName}`} className="w-full">
        Your browser cannot play this clip. Use the download link to listen.
      </audio>
      <p className="px-1 text-xs text-slate-500 dark:text-gray-400">If playback is unavailable, download the clip to listen.</p>
    </div>
  );
}
